import { isInCone, type Facing } from './MeleeCone';
import { reachToBody, type ReachBody } from './BodyReach';
import type { MeleeConeProfile } from './MeleeConeProfile';

/**
 * Plan 29 F4 + D55 — does this swing land on `targetId`? The target must sit
 * inside the swing's real cone (`resolveMeleeCone`: reach + the flat swing's
 * vertical spread), the wedge the renderer washes and the server scans. A
 * target within reach BEHIND the attacker turns them to face it first (a
 * melee press swings at your target, as it always landed), so nothing on flat
 * ground or one platform step that landed before stops landing. Returns the
 * facing to swing with, or null when the target is out of the swing.
 */
export function meleeSwingVerdict(
  origin: { x: number; y: number },
  facing: Facing,
  cone: MeleeConeProfile,
  target: ReachBody | null,
): { lands: boolean; facing: Facing } {
  if (!target) return { lands: false, facing };
  const behind = facing === 'right' ? target.x < origin.x : target.x > origin.x;
  const swingFacing: Facing = behind && reachToBody(origin, target) <= cone.rangePx
    ? (facing === 'right' ? 'left' : 'right')
    : facing;
  return { lands: isInCone(origin, swingFacing, target, cone), facing: swingFacing };
}
